import {addLocale, locale} from 'primereact/components/api/Locale';

addLocale('lt', {
    "accept": "Taip",
    "reject": "Ne",
    "choose": "Pasirinkti",
    "upload": "Siųsti",
    "cancel": "Atšaukti",
    "dayNames": ["Sekmadienis", "Pirmadienis", "Antradienis", "Trečiadienis", "Ketvirtadienis", "Penktadienis", "Šestadnies"],
    "dayNamesShort": ["Sek", "Pir", "Ant", "Tre", "Ket", "Pen", "Šes"],
    "dayNamesMin": ["Se", "Pr", "An", "Tr", "Ke", "Pn", "Še"],
    "monthNames": ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"],
    "monthNamesShort": ["Sau", "Vas", "Kov", "Bal", "Geg", "Bir", "Lie", "Rugp", "Rugs", "Spa", "Lap", "Gru"],
    "today": "Šiandien",
    "clear": "Ištrinti",
    "weekHeader": "Sav.",
    "firstDayOfWeek": 1,
    "dateFormat": "yyyy-mm-dd"

});
locale("lt")

